<template>

    <div class="knowledge-base">
        <knowledge-nav />
        <black-list />
        <posts-main-page></posts-main-page>
    </div>

</template>

<script>

import BlackList from "./BlackList/BlackList.vue";
import PostsMainPage from "./Posts/PostsMainPage.vue";
import KnowledgeNav from "./KnowledgeNav.vue";


export default {
name: "index",
    components:{
        BlackList,
        PostsMainPage,
        KnowledgeNav
    }
}
</script>

<style scoped>

</style>
